export const CHANGE_CONFIG = 'CHANGE_CONFIG';

const EMPTY = Object.freeze({});

const disableMap = {
    disableFieldVision: 'enableFieldVision',
    disableFieldVisionOD: 'enableFieldVisionOD',
    disableFieldVisionBat: 'batEnabled'
};

const changeView = (state = {}, action) => {
    const { type = null, data = {}, datasource } = action;

    if (type === CHANGE_CONFIG) {
        return Object.assign({}, state, action.viewtype);
    }

    if (type === 'dataEngine_update_response') {
        if (datasource === 'productConfig') {
            const {
                absConfig = EMPTY,
                adRefreshRate,
                context,
                DFVSyncThresholdAhead = 2,
                DFVSyncThresholdBehind = 2,
                dictionary,
                disableDynamicFieldView = false,
                disableDynamicFieldViewDesktop = false,
                disableDynamicFieldViewMobile = false,
                disableDynamicUniforms = true,
                disableWebSockets,
                enableSummaryFiltersFinal = EMPTY,
                enableSummaryFiltersLive = EMPTY,
                enableTabsFinal = EMPTY,
                enableTabsLive = EMPTY,
                epgGameday = EMPTY,
                epgGamedayById = EMPTY,
                fieldViewVenues,
                fieldVisionLiveEntitlements,
                fieldVisionODDisablePriorToDate,
                fieldVisionVenues,
                useContentEpg,
                useContentApi,
                useFallbackFV = false,
                webSocketWindow,
                sportIds,
                leagueIds,
                fieldVisionLiveFreeGameOnly,
                appContext,
                potgGameTypes,
                promos,
                dfvPlay = EMPTY
            } = data;

            const configOverride = {};

            // Special treatment for "disable" overrides
            // to ensure preconfigured flags are flipped as needed.
            for (const [key, value] of Object.entries(disableMap)) {
                if (typeof data[key] !== 'undefined' && data[key]) {
                    configOverride[value] = false;
                }
            }

            const newData = {
                ...state,
                absConfig: { ...state.absConfig, ...absConfig },
                adRefreshRate,
                context,
                DFVSyncThresholdAhead,
                DFVSyncThresholdBehind,
                dictionary,
                disableDynamicFieldView,
                disableDynamicFieldViewDesktop,
                disableDynamicFieldViewMobile,
                disableDynamicUniforms,
                disableWebSockets,
                enableSummaryFiltersFinal: { ...state.enableSummaryFiltersFinal, ...enableSummaryFiltersFinal },
                enableSummaryFiltersLive: { ...state.enableSummaryFiltersLive, ...enableSummaryFiltersLive },
                enableTabsFinal: { ...state.enableTabsFinal, ...enableTabsFinal },
                enableTabsLive: { ...state.enableTabsLive, ...enableTabsLive },
                epgGameday,
                epgGamedayById,
                fieldViewVenues,
                fieldVisionLiveEntitlements,
                fieldVisionODDisablePriorToDate,
                fieldVisionVenues,
                useContentEpg,
                useContentApi,
                useFallbackFV,
                webSocketWindow,
                sportIds,
                leagueIds,
                fieldVisionLiveFreeGameOnly,
                appContext,
                potgGameTypes,
                promos,
                dfvPlay,
                ...configOverride
            };

            return newData;
        }
    }

    return state;
};

export default changeView;
